import { ApiPermissions } from "../shared/services/volateq-api/api-permissions";
import { RouteOptions } from "../types";
const AppSettingsUsers = () => import("@/app/settings/users/users.vue");
const AppSettingsPermissions = () => import("@/app/settings/users/permissions.vue");
const AppSettingsCustomers = () => import("@/app/settings/customers/customers.vue");
const AppSettingsProductPackages = () => import("@/app/settings/product-packages/product-packages.vue");
const AppSettingsOrders = () => import("@/app/settings/orders/orders.vue");
const AppSettingsDrones = () => import("@/app/settings/drones/drones.vue");
const AppSettingsMonitoring = () => import("@/app/settings/monitoring/monitoring.vue")
const AppSettingsMlTraining = () => import("@/app/settings/ml-training/ml-training.vue");
const AppSettingsMlModels = () => import("@/app/settings/ml-models/ml-models.vue");
const AppSettingsPvTrainingExport = () =>
  import("@/app/settings/pv-training-export/pv-training-export.vue");
const AppSettingsCoreMetadata = () => import("@/app/settings/core-metadata/core-metadata.vue");
const AppSettingsVolafly = () => import("@/app/settings/volafly/volafly.vue");
const AppSettings = () => import("@/app/settings/settings.vue");
const AppUserProfile = () => import("@/app/settings/user-profile/user-profile.vue");
const AppPricing = () => import("@/app/settings/pricing/pricing.vue");

const settingsRoutes: RouteOptions[] = [
  {
    path: "/settings/",
    component: AppSettings,
    children: [
      {
        path: "users",
        name: "Users",
        component: AppSettingsUsers,
        meta: {
          permission: [ApiPermissions.READ_USER],
          title: "users",
          subtitle: "users_descr",
          adminOnly: false,
        },
      },
      {
        path: "permissions",
        name: "Permissions",
        component: AppSettingsPermissions,
        meta: {
          permission: [ApiPermissions.READ_PERMISSION],
          fluid: true,
        },
      },
      {
        path: "customers",
        name: "Customers",
        component: AppSettingsCustomers,
        meta: {
          permission: [ApiPermissions.READ_CUSTOMER],
          title: "customers",
          subtitle: "customers_descr",
          adminOnly: true,
        }
      },
      {
        path: "product-packages",
        name: "ProductPackages",
        component: AppSettingsProductPackages,
        meta: {
          permission: [ApiPermissions.READ_PRODUCT_PACKAGE],
          title: "product-packages",
          subtitle: "product-packages_descr",
          adminOnly: true,
        },
      },
      {
        path: "orders",
        name: "orders",
        component: AppSettingsOrders,
        meta: {
          permission: [ApiPermissions.READ_ORDER],
          title: "orders",
          adminOnly: true,
        }
      },
      {
        path: "drones",
        name: "drones",
        component: AppSettingsDrones,
        meta: {
          permission: [ApiPermissions.READ_DRONE],
          title: "drones",
          adminOnly: true,
        }
      },
      {
        path: "monitoring",
        name: "AnalysisMonitoring",
        component: AppSettingsMonitoring,
        meta: {
          permission: [ApiPermissions.READ_QFLY_SERVER, ApiPermissions.READ_RUNPOD_SERVER, ApiPermissions.READ_ADMIN_TASK],
          title: "operations-monitoring",
          subtitle: "operations-monitoring_expl",
          adminOnly: true,
        },
      },
      {
        path: "ml-training",
        name: "MlTraining",
        component: AppSettingsMlTraining,
        meta: {
          permission: [ApiPermissions.READ_ML_TRAINING],
          title: "ml-training",
          subtitle: "ml-training_expl",
          adminOnly: true,
        },
      },
      {
        path: "ml-models",
        name: "MlModels",
        component: AppSettingsMlModels,
        meta: {
          permission: [ApiPermissions.READ_ML_TRAINING],
          title: "ml-models",
          subtitle: "ml-models_expl",
          adminOnly: true,
        },
      },
      {
        path: "pv-training-export",
        name: "PvTrainingExport",
        component: AppSettingsPvTrainingExport,
        meta: {
          permission: [ApiPermissions.READ_ML_TRAINING],
          title: "pv-training-export",
          subtitle: "pv-training-export_expl",
          adminOnly: true,
        },
      },
      {
        path: "core-metadata",
        name: "CoreMetadata",
        component: AppSettingsCoreMetadata,
        meta: {
          permission: [ApiPermissions.UPDATE_CORE_METADATA],
          title: "core-metadata",
          subtitle: "core-metadata_expl",
          adminOnly: true,
        },
      },
      {
        path: "volafly",
        name: "Volafly",
        component: AppSettingsVolafly,
        meta: {
          permission: [ApiPermissions.READ_VOLAFLY_LOG],
          title: "volafly",
          subtitle: "volafly_expl",
          adminOnly: true,
        },
      },
      {
        path: "user-profile",
        name: "UserProfile",
        component: AppUserProfile,
        meta: {
          title: "user-profile",
        }
      },
      {
        path: "pricing",
        name: "Pricing",
        component: AppPricing,
        meta: {
          title: "pricing",
          subtitle: "pricing_descr",
        }
      }
    ],
  },
];

export default settingsRoutes;
